var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 50,
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_295",
    "data-name": "\\uADF8\\uB8F9 295",
    transform: "translate(-1124 -273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_294",
    "data-name": "\\uADF8\\uB8F9 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(1060 273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_217",
    "data-name": "\\uD328\\uC2A4 217",
    d: "M256,0C150.112,0,64,86.112,64,192c0,133.088,173.312,307.936,180.672,315.328a16.069,16.069,0,0,0,22.656,0C274.688,499.936,448,325.088,448,192,448,86.112,361.888,0,256,0Z",
    fill: "#2196f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_293",
    "data-name": "\\uADF8\\uB8F9 293",
    transform: "translate(-919.322 36.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_284",
    "data-name": "\\uADF8\\uB8F9 284",
    transform: "translate(2125.35 333.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_67",
    "data-name": "\\uD328\\uC2A4 67",
    d: "M147.781,134.387a27.585,27.585,0,0,1,6.465,10.387A23.253,23.253,0,1,1,177.918,121.2a27.753,27.753,0,0,1-10.4-6.551l-2.957-2.953a13.954,13.954,0,0,0-19.734,19.734Zm0,0",
    transform: "translate(-131.439 -98.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_68",
    "data-name": "\\uD328\\uC2A4 68",
    d: "M207,114.645a27.69,27.69,0,0,1-10.383,6.473,23.25,23.25,0,1,1,23.578,23.664,27.66,27.66,0,0,1,6.551-10.395l2.949-2.961a13.954,13.954,0,0,0-19.734-19.734Zm0,0",
    transform: "translate(-23.14 -98.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_69",
    "data-name": "\\uD328\\uC2A4 69",
    d: "M226.738,173.855a27.56,27.56,0,0,1-6.465-10.383A23.25,23.25,0,1,1,196.6,187.059a27.656,27.656,0,0,1,10.4,6.551l2.957,2.941a13.954,13.954,0,0,0,19.734-19.734Zm0,0",
    transform: "translate(-23.14 10.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_70",
    "data-name": "\\uD328\\uC2A4 70",
    d: "M167.527,193.6a27.588,27.588,0,0,1,10.383-6.457,23.25,23.25,0,1,1-23.578-23.676,27.878,27.878,0,0,1-6.551,10.4l-2.949,2.953a13.954,13.954,0,0,0,19.734,19.734Zm0,0",
    transform: "translate(-131.439 10.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_71",
    "data-name": "\\uD328\\uC2A4 71",
    d: "M319.815,270.986a88.675,88.675,0,0,1,0-125.425L334.7,130.654l-15.678-15.67-14.887,14.879a88.683,88.683,0,0,1-125.435,0l-14.915-14.879-15.669,15.67L163,145.561a88.706,88.706,0,0,1,.056,125.388l-14.943,14.935L163.8,301.563l14.9-14.879a88.683,88.683,0,0,1,125.435,0l14.9,14.879L334.7,285.883Zm0,0",
    transform: "translate(-131.439 -98.299)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerIcon);
export default __webpack_public_path__ + "static/media/workerIcon.aae850e0e8851e299426512581607645.svg";
export { ForwardRef as ReactComponent };